import { FC } from 'react'
import styles from './TocMenu.module.css'
import { BasicStyledComponent, DSPageSection } from 'shared-definitions/types'
import TocMenuSubMenu from './TocMenuSubMenu'
import clsx from 'clsx'

interface TocMenuProps extends BasicStyledComponent {
  currentSection: null | DSPageSection
  sectionItems: readonly DSPageSection[]
  onMenuItemClick?: (section: DSPageSection) => void
}

const TocMenu: FC<TocMenuProps> = ({
  currentSection,
  className,
  sectionItems,
  onMenuItemClick,
}) => (
  <div className={clsx(styles.container, className)}>
    <TocMenuSubMenu
      currentSection={currentSection}
      size="large"
      sectionItems={sectionItems}
      onMenuItemClick={onMenuItemClick}
    />
  </div>
)

export default TocMenu
